const NON_DELETABLE_TAGS = ['Positive Sentiment', 'Negative Sentiment', 'Neutral Sentiment'];

export {
  NON_DELETABLE_TAGS,
};
